<span i18n="@@ChooseCatalogPlaceholder">{{ header }}</span>

<button type="button" status="control" nbButton size="small" (click)="openChooseCatalogModal()">
  <nb-icon icon="list-outline"/>
</button>
